import React, { useState,useEffect } from 'react';
import { DownloadFile } from './Function';
import { Row,Col,Card,Placeholder, Button } from 'react-bootstrap';
const FacilitiesEbooks = () => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[MiscellaneousType,setMiscellaneousType]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneousType/byId/11");
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImage")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.mt_id + "/miscImageHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscImage = (el.upp.length > 0) ? global.config.uploadPath + el.upp[0].up_fname + el.upp[0].up_ext : '';
                            result[i].miscImageHi = (el.upb.length > 0) ? global.config.uploadPath + el.upb[0].up_fname + el.upb[0].up_ext : '';
                        });
                        setMiscellaneousType(result);
                    }).catch(error => 
                    {
                        console.error('MiscellaneousType File :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousType : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        MiscellaneousType();
    },[])
    return (
        <React.Fragment>
            {isLoading ? ( 
                <Card className=' mb-4'>
                    <Card.Header className='text-center fs-3 text-uppercase'><Placeholder xs={10} /></Card.Header>
                    <Card.Body>
                        <Row className='g-3'>
                            {[...Array(6)].map((_,index)=>(
                            <Col md={4} key={index} >
                                <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                                    <Placeholder xs={12} style={{height:"200px"}} />
                                    <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                                        <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                                        <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                                    </Card.ImgOverlay>
                                </Card>
                            </Col>
                            ))}
                        </Row>
                    </Card.Body>
                </Card>
            ) : (
                <React.Fragment>
                {MiscellaneousType.map((mt,index)=>(
                <Card className=' mb-4' key={index}>
                    <Card.Header className='text-center fs-3 text-uppercase'>
                        {appLanguage === 'hi' ? 'ई-पुस्तकें' : 'E-BOOKS'}
                    </Card.Header>
                    <Card.Body>
                        <MiscellaneousList mtId={mt.mt_id} mtImage={ appLanguage === 'hi' ? mt.miscImageHi || mt.miscImage : mt.miscImage } />
                    </Card.Body>
                </Card>
                ))}
                </React.Fragment>
            )}
        </React.Fragment>
    );
}
export default FacilitiesEbooks;
const MiscellaneousList = ({mtId,mtImage}) => 
{
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    const[isLoading, setLoading] = useState(true);
    const[Miscellaneous,setMiscellaneous]=useState([]);
    useEffect(()=>
    {
        const MiscellaneousByType = async () => 
        {
            try 
            {
                const response = await fetch(global.config.API_URL+"miscellaneous/byTypeAll/"+mtId);
                const result = await response.json();
                if(result.length > 0 )
                {
                    Promise.all(
                        result.map(e => {
                            const fetch1 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFile")
                                .then(upp => upp.json());
                            const fetch2 = fetch(global.config.API_URL + "upload/details/0/" + e.sm_id + "/miscFileHi")
                                .then(upb => upb.json());
                            return Promise.all([fetch1, fetch2])
                                .then(([upp, upb]) => {
                                    return {
                                        ...e,
                                        upp,
                                        upb
                                    };
                                });
                        })
                    ).then(allResponse => {   
                        allResponse.forEach((el, i) => {
                            result[i].miscFile = el.upp;
                            result[i].miscFileHi = el.upb;
                        });
                        setMiscellaneous(result);
                    }).catch(error => 
                    {
                        console.error('Miscellaneous File :', error);
                    });
                }
                if( global.config.IsPrint === true ) { console.info('MiscellaneousByType : Result',result); }
            }
            catch (error) 
            {
                console.error('MiscellaneousByType : Error', error.message);
            }
            finally
            {
                setLoading(false);
            }
        };
        MiscellaneousByType();   
    },[mtId,mtImage])
    return (
        <React.Fragment>
        {isLoading ? (
            <Row className='g-3'>
                {[...Array(6)].map((_,index)=>(
                <Col md={4} key={index} >
                    <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                        <Placeholder xs={12} style={{height:"200px"}} />
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                            <Card.Title className='w-100'><Placeholder xs={12} bg="light" /></Card.Title>
                            <Button className="btn btn-light w-50"><Placeholder xs={10} /></Button>
                        </Card.ImgOverlay>
                    </Card>
                </Col>
                ))}
            </Row>   
            ) : (
            <Row className='g-3'>
                {Miscellaneous.map((sm,index)=>(
                <Col md={3} key={index} >
                    <Card className="text-bg-dark text-center" data-aos="flip-up" data-aos-duration="1000">
                        <Card.Img src={mtImage} alt={appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name} />
                        <Card.ImgOverlay className='d-flex flex-column align-items-center justify-content-center bg-dark bg-opacity-75'>
                            <Card.Title>{appLanguage === 'hi' ? (sm.sm_display_en === "1" ? sm.sm_name_hi || '' : sm.sm_name_hi || sm.sm_name) : sm.sm_name}</Card.Title>
                            <span dangerouslySetInnerHTML={{ __html: DownloadFile(appLanguage,sm.miscFile,sm.miscFileHi)}} />                            
                            {sm.sm_link && 
                            <a href={sm.sm_link} target="_blank" rel="noopener noreferrer" className="btn btn-light mt-3">
                                {appLanguage === 'hi' ? "यहाँ क्लिक करें" : "Click Here"}
                            </a>}
                        </Card.ImgOverlay>
                    </Card>
                </Col>
                ))}
            </Row>
        )}        
        </React.Fragment>
    );
}